<template>
  <div>
    <heads />
    <div :class="[
      $route.meta.id == 10 || $route.meta.id == 59 ? ' cen' : ' ',
      $route.meta.id == 20 || $route.meta.id == 58 || $route.meta.id == 35 || $route.meta.id == 60 || $route.meta.id == 61 ? ' cent' : '',
      $route.meta.id == 17 ? ' cens' : '',
    ]" :style="{
      backgroundImage: 'url(' + require('@/assets/' + backgroud) + ')',
    }">
      <div class="cen_box">
        <div :class="[
          $route.meta.id == 17 ? 'cen-tops' : 'cen-top',
          $route.meta.id == 10 ? ' train' : ' ',
          $route.meta.id == 20 ? ' duomei' : ' ',
          $route.meta.id == 58 ? 'medicine' : '',
          $route.meta.id == 59 ? 'children-culture' : '',
          $route.meta.id == 35 || $route.meta.id == 60 ? 'literacy-chinese-character' : '',
        ]">
          <div class="link-wrap" v-if="$route.meta.id == 59 && videoList.length > 0"><a
              href="/video/childrenCulture/literacy" class="i-item">
              字源识字
            </a>
          </div>
          <div class="link-wrap" v-if="$route.meta.id == 59 && videoList.length > 0"><a
              href="/video/childrenCulture/chineseCharacter" class="i-item">
              汉字动画
            </a>
          </div>
          <div class="link-wrap" v-for="(item, index) in videoList" :key="index">
            <router-link :to="item.link_url != '' && item.link_url != null ? item.link_url : {
              path: pathUrl,
              query: { id: item.id },
            }" class="i-item">
              {{ item.name }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <foot />
  </div>
</template>
<script>
import "@css/ico.css";
import "@css/foot.css";
import heads from "@components/head.vue";
import foot from "@components/foot.vue";
import { getVideoList } from "@api/public";
export default {
  components: {
    heads,
    foot,
  },
  props: {},
  data() {
    return {
      videoList: [],
      queryWhere: {},
      backgroud: "",
      pathUrl: ""
    };
  },
  mounted: function () {
    let that = this;
    that.videoList = []
    let videoCateId = this.$route.meta.id;
    getVideoList({ course_cate_id: videoCateId, limit: 30 }).then(function (res) {
      let videoListTemp = res.data.list.map((item) => {
        if (videoCateId == 20) {
          if ((item.name).indexOf("《") == -1) {
            item.name = "《" + item.name;
          }
          if ((item.name).indexOf("上") == -1 && (item.name).indexOf("下") == -1 && (item.name).indexOf("》") == -1) {
            item.name = item.name + "》";
          }
          if ((item.name).indexOf("上") != -1) {
            item.name = (item.name).substring(0, (item.name).indexOf("上")) + "》（上）"
          }
          if ((item.name).indexOf("下") != -1) {
            item.name = (item.name).substring(0, (item.name).indexOf("下")) + "》（下）"
          }
        }
        return item;
      });
      that.$set(that, "videoList", videoListTemp);
    });
  },
  created: function () {
    document.title = this.$route.meta.title;
    this.backgroud = this.$route.meta.background;
    this.pathUrl = this.$route.meta.path;
  },
  watch: {
    $route(to, from) {
      this.videoList = []
      this.$router.go(0);
    },
  },
  methods: {},
};
</script>
<style scoped>
.cen {
  width: 100%;
  min-width: 1484px;
  height: 1095px;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;
}

.cens {
  width: 100%;
  min-width: 1484px;
  height: 1195px;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;
}

.cent {
  width: 100%;
  min-width: 1484px;
  height: 1195px;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;
}

.cen_box {
  width: 1484px;
  /* height: 2449px; */
  margin: 0 auto;
  position: relative;
}

.cen-top {
  position: absolute;
  width: 400px;
  height: 420px;
  top: 320px;
  left: 640px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
}

.cen-tops {
  height: 420px;
  position: absolute;
  top: 308px;
  left: 485px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.cen-top.duomei {
  top: 325px;
  width: 650px;
  left: 460px;
  justify-content: flex-start;
}

.cen-top.medicine {
  top: 425px;
  width: 1050px;
  left: 340px;
  justify-content: flex-start;
}

.cen-top.children-culture {
  top: 425px;
  width: 1050px;
  left: 640px;
  justify-content: flex-start;
}

.cen-top.literacy-chinese-character {
  top: 450px;
  width: 1050px;
  left: 640px;
  justify-content: flex-start;
}


.cen-top.anst {
  top: 1475px;
  width: 650px;
  left: 460px;
  justify-content: flex-end;
}

.link-wrap {
  width: 30px;
  margin: 0 17px;
}

.i-item {
  display: inline-block;
  width: 30px;
  color: #000;
  text-decoration: none;
  font-size: 22px;
  font-family: "kaiti";
  font-weight: bold;
  writing-mode: vertical-lr;
}

.i-item:hover {
  color: #e2cea0;
}

.cen-topst {
  display: none;
}
</style>